import styled from 'styled-components';
import { Footer } from '@veneer/core';

export const Container = styled.div`
  background-color: #fafafa;
  color: #000000;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 42px);
  max-height: 100%;
  width: 100vw;
  max-width: 100%;
`;

export const Img = styled.img`
  margin: 12px 67.7px;
  height: 40px;
  width: 40px;
`;

export const FeedbackText = styled.div`
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
`;

export const CustomFooter = styled(Footer)`
  div:first-child {
    justify-content: center;
    background-color: #fafafa;
    padding: 0;
    border: none;
  }
`;

export const CopyrightText = styled.p`
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  margin-bottom: 26px;
`;
